// @flow

import { type Merchant } from '@tectonics/prs/merchant/types';
import { getPaymentPageLogoUrl } from './config/get-payment-page-logo-url';

export function getMerchantLogo(merchant: Merchant): string {
  const paymentPageLogoUrl = getPaymentPageLogoUrl(merchant);

  if (paymentPageLogoUrl) {
    return paymentPageLogoUrl;
  }

  return merchant['logo'];
}
